<template>
  <Card class="layout-card" style="height: 100%">
    <div
      style="
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        flex-shrink: 0;
      "
    >
      <div class="search-form">
        <Input
          :maxlength="100"
          v-model="searchForm.langName"
          placeholder="请输入语言名称"
        />
        <Input
          :maxlength="100"
          v-model="searchForm.langCode"
          placeholder="请输入语言代码"
        />
        <div>
          <Select
            style="width: 140px"
            v-model="searchForm.langStatus"
            placeholder="请选择"
            allow-clear
          >
            <Option :value="1">启用</Option>
            <Option :value="0">禁用</Option>
          </Select>
        </div>
        <Button
          type="primary"
          v-if="buttonMenu['/lang/view']"
          @click="getData()"
          >查询</Button
        >
        <Button @click="handleReset()">重置</Button>
      </div>
      <div>
        <Button
          type="primary"
          v-if="buttonMenu['/lang/add']"
          @click="handleOpenEditModal()"
          >添加</Button
        >
      </div>
    </div>
    <div style="height: 100%; overflow: auto">
      <Table :data="tableData" :columns="columns">
        <template #status="{ row }">
          <div>
            <i-switch
              v-if="buttonMenu['/lang/switch/1']"
              :value="row.langStatus"
              :before-change="() => handleChangeStatus(row)"
              @on-change="row.langStatus = $event"
            ></i-switch>
            <span v-else>{{ row.langStatus ? '开启' : '禁用' }}</span>
          </div>
        </template>
        <template #action="{ row }">
          <div>
            <a
              style="margin-left: 10px"
              v-if="buttonMenu['/lang/edit']"
              @click="handleOpenLangModal(row)"
              >添加语言文本</a
            >
            <a
              style="margin-left: 10px"
              v-if="buttonMenu['/lang/edit']"
              @click="handleOpenEditModal(row)"
              >编辑</a
            >
            <Poptip
              confirm
              title="确定要删除吗？"
              v-if="buttonMenu['/lang/delete']"
              transfer
              @on-ok="handleDel(row)"
              ><a style="margin-left: 10px; color: red">删除</a></Poptip
            >
          </div>
        </template>
        <Pages slot="footer" :page="page" :func="getData"></Pages>
      </Table>
    </div>

    <Modal v-model="editVisible" :title="(form.id ? '编辑' : '新增') + '语言'">
      <Form
        @submit.native.prevent
        :label-width="100"
        :model="form"
        ref="formRef"
        v-if="editVisible"
      >
        <FormItem
          label="语言名称："
          prop="langName"
          :rules="[{ required: true, message: '请输入语言名称' }]"
        >
          <Input :maxlength="100" v-model="form.langName" />
        </FormItem>
        <FormItem
          label="中文名称："
          prop="chineseLangName"
          :rules="[{ required: true, message: '请输入中文名称' }]"
        >
          <Input :maxlength="100" v-model="form.chineseLangName" />
        </FormItem>
        <FormItem
          label="语言代码："
          prop="langCode"
          :rules="[{ required: true, message: '请输入语言代码' }]"
        >
          <Input :maxlength="20" v-model="form.langCode" />
        </FormItem>
        <FormItem
          label="颜色："
          prop="langColor"
          :rules="[{ required: true, message: '请选择颜色' }]"
        >
          <input type="color" v-model="form.langColor" />
        </FormItem>
        <FormItem
          label="语言状态："
          prop="langStatus"
          :rules="[{ required: true, message: '请选择' }]"
        >
          <i-switch v-model="form.langStatus" />
        </FormItem>
      </Form>
      <template #footer>
        <Button @click="editVisible = false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit()"
          >提交</Button
        >
      </template>
    </Modal>
    <Modal v-model="langModalVisible" :width="1200" :title="form.langName">
      <langMain v-if="langModalVisible" :form="form" ref="langTrans"></langMain>
      <template #footer>
        <Button @click="langModalVisible = false">关闭</Button>
        <Button
          @click="handleSubmitTrans"
          type="primary"
          :loading="transLoading"
          >确认</Button
        >
      </template>
    </Modal>
  </Card>
</template>

<script>
import Pages from '@/components/pages'
import langMain from './main.vue'
import {
  getLangList,
  addLang,
  delLang,
  editLang,
  getLangInfo,
  changeLangStatus
} from '@/api/lang'
export default {
  components: {
    Pages,
    langMain
  },
  data() {
    return {
      editVisible: false,
      langModalVisible: false,
      form: {},
      searchForm: {},
      submitLoading: false,
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      columns: [
        // {
        //   title: 'id',
        //   key: 'id'
        // },
        {
          title: '语言名称',
          key: 'langName'
        },
        {
          title: '中文名称',
          key: 'chineseLangName'
        },
        {
          title: '语言代码',
          key: 'langCode'
        },
        {
          title: '颜色',
          key: 'langColor',
          render: (h, params) => {
            return (
              <div
                style={{
                  width: '20px',
                  height: '10px',
                  background: params.row.langColor
                }}
              ></div>
            )
          }
        },
        {
          title: '状态',
          key: 'langStatusName',
          slot: 'status'
        },
        {
          title: '创建人',
          key: 'createUserName'
        },
        {
          title: '创建时间',
          key: 'createTimeFmt'
        },
        {
          title: '修改人',
          key: 'updateUserName'
        },
        {
          title: '修改时间',
          key: 'updateTimeFmt'
        },
        {
          title: '操作',
          align: 'center',
          width: 200,
          slot: 'action'
        }
      ],
      transLoading: false
    }
  },
  computed: {
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('tags/lang')
      const obj = {}
      li.forEach((i) => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods: {
    handleOpenLangModal(row) {
      this.form = { ...row }
      this.langModalVisible = true
    },
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getLangList({
        ...this.page,
        ...this.searchForm
      }).then(({ data }) => {
        console.log(data)

        this.tableData = data.records
        this.page.current = data.current
        this.page.total = data.total
      })
    },
    async handleSubmitTrans() {
      try {
        this.transLoading = true
        await this.$refs.langTrans.handleEdit()
      } finally {
        this.transLoading = false
      }
    },
    handleChangeStatus(row) {
      changeLangStatus(row.id)
        .then((r) => {
          this.$Message.success('操作成功')
          this.getData(this.page.current)
        })
        .catch((e) => {
          this.$Message.error('操作失败')
        })
      return new Promise(() => {})
    },
    async handleOpenEditModal(row) {
      if (row) {
        const r = await getLangInfo(row.id)
        this.form = r.data
      } else {
        this.form = {
          langStatus: false
        }
      }
      this.editVisible = true
    },
    handleSubmit() {
      this.$refs.formRef.validate((r) => {
        if (r) {
          const func = this.form.id ? editLang : addLang
          this.submitLoading = true
          func({
            ...this.form
          })
            .then((r) => {
              this.$Message.success('操作成功')
              this.getData()
              this.submitLoading = false
              this.editVisible = false
            })
            .catch(() => {
              this.submitLoading = false
            })
        }
      })
    },
    handleDel(row) {
      delLang(row.id).then((r) => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="less">
.search-form {
  display: flex;
  & > * {
    margin: 0 5px;
  }
}
.layout-card {
  /deep/ .ivu-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>
